module.exports = __webpack_public_path__ + "static/commerce2x-vuejs-5279fe4f4adcfaf65b916f295380ccdd.png";